import { AppRouteProps } from "@harea/component";
import React from "react";
import PaymentDetails from "./container/PaymentDetails";

// const PaymentDetails = React.lazy(() => import("./container/PaymentDetails"));

export const DetailsRoutes = [
    {
        path: ":id",
        element: <PaymentDetails />,
        title: "Harea.Billing.Details.Title",
    },
] as Array<AppRouteProps>;
